import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const DocumentIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        style={customStyle}
        height={size}
        fill="none"
        viewBox="0 0 16 20"
      >
        <path
          fill="currentColor"
          d="M3.315 19.182h9.37c1.89 0 2.865-.993 2.865-2.892V8.31c0-1.23-.158-1.793-.923-2.576L10.03 1.067C9.283.312 8.668.136 7.56.136H3.316c-1.88 0-2.865.993-2.865 2.9V16.29c0 1.899.985 2.892 2.865 2.892m.15-1.758c-.844 0-1.266-.44-1.266-1.248V3.142c0-.8.422-1.248 1.275-1.248H7.2v4.78c0 1.275.624 1.89 1.89 1.89h4.71v7.612c0 .808-.421 1.248-1.274 1.248zM9.257 7.026c-.37 0-.528-.158-.528-.518V2.122l4.835 4.904zm1.837 3.841H4.748c-.334 0-.571.237-.571.545 0 .316.237.563.571.563h6.346a.55.55 0 0 0 .554-.563.54.54 0 0 0-.554-.545m0 2.936H4.748a.55.55 0 0 0-.571.562c0 .308.237.545.571.545h6.346a.54.54 0 0 0 .554-.545.55.55 0 0 0-.554-.562"
        ></path>
      </svg>
    </div>
  );
};

export default DocumentIcon;
